import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Welcome from '../components/Welcome';
import Login from '../components/Authentication/Login';
import Profile from '../components/Authentication/Profile';
import Dashboard from '../components/Dashboard';
import Benchmarking from '../components/Benchmarking';
import TrendingScores from '../components/TrendingScores';
import Assessment from '../components/Assessment';
import Learning from '../components/Learning';
import TrainingVideos from '../components/Learning/LQATraining';
import TrainingVideoVisualilzer from '../components/Learning/TrainingVideoVIsualizer';
import Standards from '../components/Learning/Standards/index';
import Newsfeed from '../components/Newsfeed';
import ArticleReaderView from '../components/Newsfeed/ArticleReaderView';
import AssessmentStandard from '../components/AssessmentStandard';
import MyActions from '../components/MyActions';
import CreateActionPlan from '../components/CreateActionPlan';
import MissedStandard from '../components/MissedStandard';
import ActionPlansSeries from '../components/ActionPlansSeries';
import SelfAssessments from '../components/SelfAssessments';
import ViewSelfAssessment from '../components/ViewSelfAssessment';
import SelfAssessmentSummary from '../components/SelfAssessmentSummary';
import EditActionPlan from '../components/EditActionPlan';
import EditSelfAssessment from '../components/EditSelfAssessment';
import SelfAssessmentSummaryStandards from '../components/SelfAssessmentSummaryStandards';
import { Notifications } from '../app/pages/Notifications';
import PrivateRoutes from './PrivateRoutes';
import OneTimeRoutes from './OneTimeRoutes';
import Success from '../components/Success';
import CreateProfile from './../components/CreateProfile';
import PilotWelcome from '../components/PilotWelcome';
import PinCode from '../components/PinCode';
import Quizzes from '../components/Learning/Quizzes';
import TakeQuiz from '../components/Learning/Quizzes/TakeQuiz';
import DirectLogin from '../components/DirectLogin';
import EITraining from '../components/Learning/EITraining';
import ForgotPassword from '../components/ForgotPassword';
import ForgotPasswordSuccess from '../components/ForgotPasswordSuccess';
import ForgotPasswordChange from '../components/ForgotPasswordChange';
import Settings from '../components/Settings';
import StartCV from '../components/StartCV';
import UserProfileCV from '../components/UserProfileCV';
import EditCV from '../components/EditCV';
import MyLQAProfile from '../components/MyLQAProfile';
import RegisterSuccess from '../components/RegisterSuccess';
import SignIn from '../components/MyLQAProfile/SignIn';
import Relogin from '../components/Relogin';
import MandarinCustom from '../components/Learning/Mandarin/MandarinCustom';
import TrainingVideoList from '../components/Learning/Mandarin/TrainingVideoList';
import { getItem } from '../utils/localStorage';

// Boosters
import { Boosters } from '../app/Learning/Boosters/Boosters';
import { MyBooster } from '../app/Learning/Boosters/MyBoosters';
import { MyDailyBooster } from '../app/Learning/Boosters/MyDailyBooster';

// myAudit
import { MyAuditAssign } from '../app/pages/MyAudit/MyAuditAssign';
import { MyAuditPreview } from '../app/pages/MyAudit/MyAuditPreview';
import { MyAuditSummary } from '../app/pages/MyAudit/MyAuditSummary';
import { MyAuditView } from '../app/pages/MyAudit/MyAuditView';
import { MyAuditConduct } from '../app/pages/MyAudit/MyAuditConduct';
import { MyAuditDetails } from '../app/pages/MyAudit/MyAuditDetails';
import { MyAuditList } from '../app/pages/MyAudit/MyAuditList';
import { MyAuditSections } from '../app/pages/MyAudit/MyAuditSections';
import { PlaygroundTechHelpHub } from '../app/pages/PlaygroundTechHelpHub/index';
import { MyAuditChecklist } from '../app/pages/MyAudit/MyAuditChecklist';

// SelfAssessment
import { SelfAssessmentSelectDepartment } from '../app/pages/SelfAssessment/SelfAssessmentSelectDepartment';
import { SelfAssessmentAssing } from '../app/pages/SelfAssessment/SelfAssessmentAssign';
import { ActionPlanList } from '../app/pages/ActionPlan/ActionPlanList';
import { SelfAssessmentPreview } from '../app/pages/SelfAssessment/SelfAssessmentPreview';
import { LearningGame } from '../app/pages/LearningGame';

function AppRouter () {
  const selectedBrand = getItem('selectedBrand');

  return (
    <Routes>
      <Route element={<OneTimeRoutes />}>
        <Route path="/" element={<Welcome />} />
        <Route path="/playgroundHelp" element={<PlaygroundTechHelpHub />} />
        <Route path="/login" element={<Login />} />
        <Route path="/myLQAProfile" element={<MyLQAProfile />} />
        <Route path="/createProfile" element={<CreateProfile />} />
        <Route path="/success" element={<Success />} />
        <Route path="/register-success/:origin" element={<RegisterSuccess />} />
        <Route
          path="/forgotpasswordsuccess"
          element={<ForgotPasswordSuccess />}
        />
        <Route path="/emailverification" element={<ForgotPasswordChange />} />
      </Route>
      <Route path="/directLogin/" element={<DirectLogin />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/register/activationCode" element={<PinCode />} />
      <Route path="/relogin/" element={<Relogin />} />
      <Route path="/myLqaProfile/signIn" element={<SignIn />} />
      <Route element={<PrivateRoutes />}>
        <Route path="/profile" element={<Profile />} />
        <Route path="/success" element={<Success />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/assessments" element={<Assessment />} />
        <Route path="/myactions" element={<MyActions />} />
        <Route path="/newsfeed" element={<Newsfeed />} />
        <Route path="/newsfeed/read/:id" element={<ArticleReaderView />} />
        <Route path="/learning" element={<Learning />} />
        <Route path="/learning/quizzes" element={<Quizzes />} />
        <Route path="/learning/quizzes/take-quiz/:id" element={<TakeQuiz />} />
        <Route path="/learning/training_videos" element={<TrainingVideos />} />
        <Route path="/learning/eitraining" element={<EITraining />} />
        <Route path="/learning/boosters" element={<Boosters />} />
        <Route path="/learning/myBooster" element={<MyBooster />} />
        <Route path="/learning/dailyBooster" element={<MyDailyBooster />} />
        {selectedBrand === 26 && (
          <Route
            path="/learning/custom_mandarin"
            element={<MandarinCustom />}
          />
        )}
        <Route
          path="/learning/watch-video/:id"
          element={<TrainingVideoVisualilzer />}
        />
        {selectedBrand === 26 && (
          <Route
            path="/learning/watch-video/mandarin/:id"
            element={<TrainingVideoList />}
          />
        )}
        <Route path="/learning/standards" element={<Standards />} />
        <Route path="/benchmarking" element={<Benchmarking />} />
        <Route path="/trendingScores" element={<TrendingScores />} />
        <Route path="/assesmentStandard" element={<AssessmentStandard />} />
        <Route path="/actionPlans" element={<MyActions />} />
        <Route path="/actionPlanList" element={<ActionPlanList />} />
        <Route
          path="/actionPlansSeries/:evnt/:assessmentId/:parentId/:id"
          element={<ActionPlansSeries />}
        />
        <Route path="/createActionPlan" element={<CreateActionPlan />} />
        <Route
          path="/editActionPlan/:root/:evnt/:id"
          element={<EditActionPlan />}
        />
        <Route path="/missedStandard" element={<MissedStandard />} />
        <Route
          path="/selfAssessments/:evnt/:OverDue/:assessmentId"
          element={<SelfAssessments />}
        />
        <Route path="/viewSelfAssessment" element={<ViewSelfAssessment />} />
        <Route
          path="/selfAssessmentSummary"
          element={<SelfAssessmentSummary />}
        />
        <Route path="/editSelfAssessment" element={<EditSelfAssessment />} />
        <Route
          path="/selfAssessmentSummaryStandards"
          element={<SelfAssessmentSummaryStandards />}
        />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/pilotwelcome" element={<PilotWelcome />} />
        <Route path="/start-cv" element={<StartCV />} />
        <Route path="/edit-cv" element={<EditCV />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/profile/cv" element={<UserProfileCV />} />
        <Route path="/learning-game" element={<LearningGame />} />

        <Route path="selfAssessment">
          <Route
            path="selectDepartments"
            element={<SelfAssessmentSelectDepartment />}
          />
          <Route path="assign" element={<SelfAssessmentAssing />} />
          <Route path="preview" element={<SelfAssessmentPreview />} />
        </Route>
        <Route path="myaudit">
          <Route path="" element={<MyAuditList />} />
          <Route path="checklist" element={<MyAuditChecklist />} />
          <Route path="sections" element={<MyAuditSections />} />
          <Route path="assign" element={<MyAuditAssign />} />
          <Route path="preview" element={<MyAuditPreview />} />
          <Route path="view" element={<MyAuditView />} />
          <Route path="conduct" element={<MyAuditConduct />} />
          <Route path="summary" element={<MyAuditSummary />} />
          <Route path="details" element={<MyAuditDetails />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default AppRouter;
